import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { listenForSync } from "./lib/marketSync";
import "./styles/app.css";

// Before render and sign-in, so a bookmarklet handoff is never missed.
listenForSync();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
